module.exports = __webpack_public_path__ + "img/gym.d2e14aee.png";